import matches from 'validator/lib/matches';
import isEmpty from 'validator/lib/isEmpty';
import {
    updateField
} from '../../actions';
import {
    EVENT_STEP_VALIDATE
} from '../../helpers/consts';
import { TextField } from "./textField";

export class CityField extends TextField {
    validate(_hideMessage = false) {
        const hideMessage = typeof _hideMessage !== 'boolean' ? false : _hideMessage;

        this.$fieldInput.classList.remove('is-valid');
        this.isValid = false;
        this.$fieldMessage.classList.toggle('visually-hidden', hideMessage);

        if (matches(this.$fieldInput.value, /(^[0-9]*$)/ig)) {
            // Valid name check on bogus data
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.notANumber.replace(/%s/g, this.label);
        } else if (matches(this.$fieldInput.value, /<[^>]+>/g)) {
            // No html allowed
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.noHTML;
        } else if (matches(this.$fieldInput.value, /[#@%!&$]/gi)) {
            // Name check on invalid characters
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.noWeirdCharacters;
        } else if (matches(this.$fieldInput.value, /((test|asdff|asdf|asdasd|qwer|xxx|demo))+/gi)) {
            // No test in the name
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.nameNoTest;
        } else {
            // Field is valid
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.add('is-valid');
            this.isValid = true;
        }

        if (isEmpty(this.$fieldInput.value)) {
            if (this.required) {
                this.$fieldInput.classList.add('is-invalid');
                this.$fieldInput.classList.remove('is-valid');
                this.isValid = false;
                this.$fieldMessage.innerHTML = this.validateMessages.isEmpty.replace(/%s/g, this.label);
            } else {
                this.$fieldInput.classList.remove('is-invalid');
                this.$fieldInput.classList.remove('is-valid');
                this.isValid = true;
            }
        }

        if(this.isValid) {
            this.store.dispatch(updateField(this.id, this.$fieldInput.value, this.isValid, this.label));
        }

        if (! this.readOnly) {
            this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
        }
    }
}

export default CityField;
